// essential tokens
export const ICP_ICP_ID = 'icp'
export const BTC_ID = 'btc'
export const ETH_ID = 'eth'
export const SOL_ID = 'sol'

// IC tokens
export const NICP_ICP_ID = 'nicp'
export const BOB_ICP_ID = 'bob'
export const CKBTC_ICP_ID = 'ckbtc'
export const CKETH_ICP_ID = 'cketh'
export const CBBTC_ICP_ID = 'cbBTC'
export const USDT_ICP_ID = 'USDT'
export const USDC_ICP_ID = 'USDC'
export const GLDT_ICP_ID = 'gldt'

// Odin tokens
export const ODINBTC_ID = 'OdinBtc'
export const ODINDOG_ID = '2jjj'

// ETH tokens
export const USDC_ETH_ID = 'usdc'
export const USDT_ETH_ID = 'usdt'
export const ICP_ETH_ID = 'icpeth'
export const CBBTC_ETH_ID = 'cbBTCeth'
export const CKBTC_ETH_ID = 'ckbtceth'
export const BOB_ETH_ID = 'bobeth'
export const GLDT_ETH_ID = 'gldteth'

// ARB tokens
export const ETH_ARB_ID = 'etharb'
export const USDC_ARB_ID = 'usdcarb'
export const BOB_ARB_ID = 'bobarb'
export const ICP_ARB_ID = 'icparb'
export const CBBTC_ARB_ID = 'cbbtcarb'
export const CKBTC_ARB_ID = 'ckbtcarb'
export const GLDT_ARB_ID = 'gldtarb'

// BASE tokens
export const ETH_BASE_ID = 'ethbase'
export const USDC_BASE_ID = 'usdcbase'
export const ICP_BASE_ID = 'icpbase'
export const BOB_BASE_ID = 'bobbase'
export const CBBTC_BASE_ID = 'cbbtcbase'
export const CKBTC_BASE_ID = 'ckbtcbase'
export const GLDT_BASE_ID = 'gldtbase'
